import { reactive, watch, ref, toRefs } from "vue";
import { postMatchKnockoutList } from "@/api/home-page";

function useHomePageKnockout(homePageState, pageState) {
  const firstHalf = ref([]);
  const secondHalf = ref([]);

  const knockoutState = reactive({});

  const _normalizeKnockoutData = (original) =>
    original.map((item) => ({
      redTeamId: item.red_match_team_id,
      redTeamName: item.red_match_team.match_team_name,
      blueTeamId: item.blue_match_team_id,
      blueTeamName: item.blue_match_team.match_team_name,
      victoryTeamId: item.victory_match_team_id,
      id: item.id,
      redMembers: Array.isArray(item.red_match_team.match_player_info)
        ? item.red_match_team.match_player_info
        : [],
      blueMembers: Array.isArray(item.blue_match_team.match_player_info)
        ? item.blue_match_team.match_player_info
        : [],
    }));

  /**
   * 获取淘汰赛列表
   * @param session 场次：1第一轮初赛，2第一轮复活赛，3第二轮初赛，4第二轮复活赛
   * @param zone 赛区：1是上半场， 2是下半场
   */
  const fetchKnockoutList = async (session, zone) => {
    try {
      const res = await postMatchKnockoutList({
        matchGroup: homePageState.groupType,
        matchSeason: homePageState.raceQuartertype,
        matchSession: session,
        matchZone: zone,
      });
      if (res.code === 0) {
        if (res.data.list.length === 0) {
          homePageState.isNone = true;
        } else {
          homePageState.isNone = false;
        }
        return res.data;
      }
    } catch (error) {
      console.warn("获取淘汰赛列表失败", error);
    }
    return {};
  };

  /**
   * 是否是复活赛
   * @param session 场次：1第一轮初赛，2第一轮复活赛，3第二轮初赛，4第二轮复活赛
   * @returns
   */
  const isRepechage = (session) => ![1, 3].includes(session);

  const loadFirstHalfData = async () => {
    if (!isRepechage(pageState.active)) {
      const res = await fetchKnockoutList(pageState.active, 1);
      if (res.list) {
        const normalized = _normalizeKnockoutData(res.list);
        firstHalf.value = normalized;

        // if (!isRepechage(pageState.active)) {
        //   firstHalf.value = normalized;
        // } else {
        //   // 如果是 复活赛，并且数据长度大于一
        //   // 则将数据拆成两份，因为 UI 显示也是两列的
        //   if (normalized.length > 1) {
        //     const halfIndex = Math.ceil(normalized.length / 2);
        //     firstHalf.value = normalized.slice(0, halfIndex);
        //     secondHalf.value = normalized.slice(halfIndex);
        //   } else {
        //     firstHalf.value = normalized;
        //   }
        // }
      } else {
        firstHalf.value = [];
      }
    }
  };

  const loadSecondHalfData = async () => {
    const res = await fetchKnockoutList(pageState.active, 2);
    if (res.list) {
      const normalized = _normalizeKnockoutData(res.list);
      secondHalf.value = normalized;
    }
  };

  watch(
    [
      () => homePageState.raceQuartertype,
      () => homePageState.groupType,
      () => homePageState.raceType,
      () => pageState.active,
    ],
    () => {
      loadFirstHalfData();
      loadSecondHalfData();
    },
    { immediate: true }
  );

  return {
    knockoutState: toRefs(knockoutState),
    fetchKnockoutList,
    firstHalf,
    secondHalf,
    isRepechage,
  };
}

export default useHomePageKnockout;
